<script>
  import { addCompanyInfo, updateCompanyInfo } from 'api/common/companyInfo';
  import BasePageForm from '@/views/layout/components/BasePageForm.vue';
  import LineFrame from '@/components/common/LineFrame/LineFrame.vue';
  import PageFormItem from '@/views/layout/components/PageFormItem.vue';

  const defaultFormData = {
    bankList: [],
    companyList: [],
    companyPlatform: '',
    companyEntity: '',
    companyEntityAlias: '',
    companyNameEn: '',
    companyAddress: '',
    companyPhone: '',
    companyPhoneNumber: '',
    companyAddressEn: '',
    postalCode: '',
    brn: '',
    tin: '',
  };

  const defaultBankItem = {
    bankId: null,
    bfiId: null,
    bankTags: [],
    bankName: '',
    bankAccountName: '',
    bankAccountNumber: '',
    branchCode: '',
    swiftCode: '',
    businessType: '',
  };

  export default {
    name: 'CompanyInfoBaseForm',
    components: { PageFormItem, LineFrame, BasePageForm },
    computed: {},
    props: {
      formType: {
        type: String,
        default: 'new',
      },
      dialogVisible: {
        type: Boolean,
        default: false,
      },
      editData: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        formData: Object.assign({}, defaultFormData),
        isHyperTAP: false,
        rules: {},
        bankFormRules: {},
        inputs: [{ value: '' }],
        tagInputObj: [],
        formProcessing: false,
      };
    },
    created() {
      if (!this.editData.companyPlatform) {
        this.formData = Object.assign({}, JSON.parse(JSON.stringify(defaultFormData)));
        return;
      }
      this.formData = Object.assign(
        JSON.parse(JSON.stringify(defaultFormData)),
        JSON.parse(JSON.stringify(this.editData))
      );

      if (!this.formData.bankList) {
        this.formData.bankList = [];
      }
      this.formData.bankList.forEach(() => {
        this.tagInputObj.push({
          value: '',
          visible: false,
        });
      });
    },
    methods: {
      addNewBank() {
        this.formData.bankList.push(JSON.parse(JSON.stringify(defaultBankItem)));
        this.tagInputObj.push({ value: '', visible: false });
      },
      handleSubmit() {
        let passCheck = true;
        Object.keys(this.$refs).forEach((key) => {
          if (key.includes('bank')) {
            if (this.$refs[key].length > 0) {
              this.$refs[key][0].validate((valid) => {
                if (!valid) {
                  passCheck = false;
                }
              });
            }
          } else {
            if (key.includes('Form')) {
              this.$refs[key].validate((valid) => {
                if (!valid) {
                  passCheck = false;
                }
              });
            }
          }
        });
        if (!passCheck) {
          return;
        }
        this.formProcessing = true;
        try {
          if (this.formType === 'new') {
            addCompanyInfo({ ...this.formData }).then((response) => {
              if (response.code === 200) {
                this.$message({
                  message: 'Add Success',
                  type: 'success',
                });
                this.$emit('refresh-list');
                this.handleClose();
              }
            });
          } else if (this.formType === 'edit') {
            updateCompanyInfo({ ...this.formData }).then((response) => {
              if (response.code === 200) {
                this.$message({
                  message: 'Update Success',
                  type: 'success',
                });
                this.$emit('refresh-list');
                this.handleClose();
              }
            });
          }
        } finally {
          setTimeout(() => {
            this.formProcessing = false;
          }, 500);
        }
      },
      handleClose() {
        this.$emit('update:dialogVisible', false);
        this.formData = Object.assign({}, defaultFormData);
      },
      isHyperTapChange(val) {
        if (val) {
          this.formData.companyPlatform = 'HyperTAP';
        }
      },
      handleCloseTag(tag, bankTags) {
        bankTags.splice(bankTags.indexOf(tag), 1);
      },
      showInput(index) {
        const name = `saveTagInput_${index}`;
        this.tagInputObj[index].visible = true;
        this.$nextTick(() => {
          this.$refs[name][0].$refs.input.focus();
        });
      },
      handleInputConfirm(event, index, bankTags) {
        const value = this.tagInputObj[index].value;
        if (value === '' || !value) {
          this.tagInputObj[index].visible = false;
          return;
        }
        if (bankTags.includes(value)) {
          this.$message.error(value + ' already exists');
          return;
        }
        if (value) {
          bankTags.push(value);
        }
        this.tagInputObj[index].visible = false;
        this.tagInputObj[index].value = '';
      },
      handleRemoveBankInfo(index) {
        this.formData.bankList.splice(index, 1);
      },
    },
  };
</script>

<template>
  <base-page-form :title="'Company Info Form'" @back="handleClose">
    <template #main>
      <div class="page-form">
        <div>
          <h1>Base Info</h1>
          <el-form
            label-position="left"
            label-width="180px"
            ref="baseForm"
            :model="formData"
            :rules="rules"
            :disabled="formProcessing"
            class="grid-form-large"
          >
            <el-form-item :label="$t('company.platform')" prop="companyPlatform" required>
              <el-input v-model="formData.companyPlatform" :disabled="formType === 'edit'" />
            </el-form-item>
            <el-form-item :label="$t('company.entity')" prop="companyEntity" required>
              <el-input v-model="formData.companyEntity" :disabled="formType === 'edit'" />
            </el-form-item>
            <el-form-item :label="$t('company.companyEntityAlias')" prop="companyEntityAlias">
              <el-input v-model="formData.companyEntityAlias" />
            </el-form-item>
            <el-form-item :label="$t('company.isHyperTAP')" v-show="formType === 'new'">
              <el-checkbox v-model="isHyperTAP" @change="isHyperTapChange" />
            </el-form-item>
          </el-form>
        </div>

        <div>
          <h1>Invoice Info</h1>
          <el-form
            label-position="left"
            :model="formData"
            ref="companyInfoForm"
            label-width="180px"
            class="grid-form-large"
          >
            <el-form-item :label="$t('company.nameEn')" prop="companyNameEn">
              <el-input v-model="formData.companyNameEn" />
            </el-form-item>
            <el-form-item :label="$t('company.address')" prop="companyAddress">
              <el-input v-model="formData.companyAddress" />
            </el-form-item>
            <el-form-item :label="$t('company.addressEn')" prop="companyAddressEn">
              <el-input v-model="formData.companyAddressEn" />
            </el-form-item>
            <el-form-item :label="$t('company.phone')" prop="companyPhone">
              <el-input v-model="formData.companyPhone" />
            </el-form-item>
            <el-form-item :label="$t('company.postalCode')" prop="postalCode">
              <el-input v-model="formData.postalCode" />
            </el-form-item>
            <el-form-item :label="$t('company.brn')" prop="brn">
              <el-input v-model="formData.brn" />
            </el-form-item>
            <el-form-item :label="$t('company.tin')" prop="tin">
              <el-input v-model="formData.tin" />
            </el-form-item>
          </el-form>
        </div>

        <page-form-item title="Bank Info">
          <template #header-actions>
            <el-button @click="addNewBank" type="primary">Add Bank Info</el-button>
          </template>
          <template #content>
            <el-empty v-if="formData.bankList.length === 0" description="数据不存在" />
            <div v-for="(item, index) in formData.bankList" :key="index">
              <line-frame
                :title="`Bank Info ${index + 1}`"
                :action="true"
                @removeFrame="handleRemoveBankInfo(index)"
              >
                <el-form
                  label-position="left"
                  label-width="180px"
                  class="grid-form-large"
                  :model="item"
                  :rules="bankFormRules"
                  :ref="`bankForm${index}`"
                >
                  <el-form-item :label="$t('company.bankName')" prop="bankName">
                    <el-input v-model="item.bankName" />
                  </el-form-item>
                  <el-form-item :label="$t('company.bankAddress')" prop="bankAddress">
                    <el-input v-model="item.bankAddress" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('company.bankAccountName')"
                    prop="bankAccountName"
                    required
                  >
                    <el-input v-model="item.bankAccountName" />
                  </el-form-item>
                  <el-form-item :label="$t('company.bankAccountNumber')" prop="bankAccountNumber">
                    <el-input v-model="item.bankAccountNumber" />
                  </el-form-item>
                  <el-form-item :label="$t('company.swiftCode')" prop="swiftCode">
                    <el-input v-model="item.swiftCode" />
                  </el-form-item>
                  <el-form-item :label="$t('company.branchCode')" prop="branchCode">
                    <el-input v-model="item.branchCode" />
                  </el-form-item>
                  <el-form-item :label="$t('company.tags')" prop="bankTags">
                    <el-tag
                      :key="tagIndex"
                      v-for="(tag, tagIndex) in item.bankTags"
                      closable
                      :disable-transitions="false"
                      @close="handleCloseTag(tag, item.bankTags)"
                    >
                      {{ tag }}
                    </el-tag>
                    <el-input
                      class="input-new-tag"
                      v-if="tagInputObj[index].visible"
                      v-model="tagInputObj[index].value"
                      :ref="`saveTagInput_${index}`"
                      size="small"
                      @keyup.enter.native="handleInputConfirm($event, index, item.bankTags)"
                      @blur="handleInputConfirm($event, index, item.bankTags)"
                    />
                    <el-button v-else class="button-new-tag" size="small" @click="showInput(index)"
                      >+ New Tag
                    </el-button>
                  </el-form-item>
                  <el-form-item :label="$t('company.BusinessType')" prop="businessType" required>
                    <el-radio-group v-model="item.businessType">
                      <el-radio label="ADV" value="ADV">Advertiser</el-radio>
                      <el-radio label="AFF" value="AFF">Affiliate</el-radio>
                      <el-radio label="HYPER_TAP" value="HYPER_TAP">HyperTap</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-form>
              </line-frame>
            </div>
          </template>
        </page-form-item>
      </div>
    </template>
    <template #footer>
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :disabled="formProcessing" @click="handleSubmit">确 定</el-button>
    </template>
  </base-page-form>
</template>

<style scoped lang="scss">
  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>
